<template>
    <!-- 回单反查 弹框 -->
    <el-dialog
        :closeOnClickModal="false"
        class="receiptReviewDialog"
        title="回单反查"
        :visible="true"
        :before-close="beforeClose"
        width="50%"
    >
        <div class="contentBox">
            <div class="contentBox-img">
                <div class="attachmentTitle" v-if="imgArr.length">
                    <span>上传人：{{ updateUserName }}</span>
                    <div style="padding-left: 70px">
                        {{ carouselIndex + 1 + ' / ' + imgArr.length }}
                    </div>
                    <span>上传时间：{{ updateTime }}</span>
                </div>
                <div class="attachmentLeft">
                    <div style="height: 300px" v-show="imgArr.length">
                        <ul id="viewers" style="display: none">
                            <li v-for="(item, index) in imgArr" :key="index">
                                <img :src="item.path" />
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="uploader" v-if="imgArr.length">
                    <upload-new-btn
                        ref="uploadButton"
                        type="btn"
                        multiple
                        businessKey="default"
                        bucket="c-tms"
                        contentType="application/octet-stream"
                        :needBtn="false"
                        :publicRead="1"
                        :compressImage="true"
                        :compressQuality="0.5"
                        @callback="uploadResponse"
                    >
                        <i class="el-icon-plus pictures"></i>
                    </upload-new-btn>
                    <i class="el-icon-delete" @click="deleteBtn"></i>
                    <i class="el-icon-download" @click="downloadBtn"></i>
                </div>
                <upload-new-btn
                    class="upload"
                    v-else
                    ref="uploadButton"
                    type="btn"
                    multiple
                    businessKey="default"
                    bucket="c-tms"
                    contentType="application/octet-stream"
                    :needBtn="false"
                    :publicRead="1"
                    :compressImage="true"
                    :compressQuality="0.5"
                    @callback="uploadResponse"
                >
                    <i class="el-icon-plus notImg"></i>
                </upload-new-btn>
            </div>
            <div class="contentBox-remark">
                <div>
                    反查结果：
                    <el-select v-model="recheckResult">
                        <el-option label="反查正常" value="0"></el-option>
                        <el-option label="反查异常" value="1"></el-option>
                    </el-select>
                </div>
                <div class="remark">
                    异常描述：
                    <el-input
                        class="errorInput"
                        type="textarea"
                        v-model.trim="remark"
                        :rows="10"
                    ></el-input>
                </div>
            </div>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="beforeClose">取 消</el-button>
            <el-button type="primary" @click="saveBtn">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import * as api from '@/modules/transport/otp/api/performanceReceiptBackCheck.js';
import { mapState, mapGetters } from 'vuex';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import UploadNewBtn from '@/components/lots/OSS/UploadNewBtn';

export default {
    components: {
        UploadNewBtn
    },
    props: {
        isSignCenter: { // 判断是否被签收中心引用，唯一差异是保存接口地址不同
            type: Boolean,
            default () {
                return false;
            }
        },
        reviewShow: {
            type: Boolean,
            default () {
                return false;
            }
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            remark: '',
            updateTime: '',
            updateUserName: '',
            recheckResult: '0',
            dialogLoading: { close: () => { } }, // 弹框loading实例
            viewer: {},
            carouselIndex: 0, // 轮播图当前的索引
            imgArr: []
        };
    },
    methods: {
        loading (status = true) {
            this.dialogLoading.close();
            if (status) {
                this.dialogLoading = this.$loading({
                    target: '.receiptReviewDialog > div',
                    background: 'rgba(255, 255, 255, .7)'
                });
            } else {
                this.dialogLoading.close();
            }
        },
        saveBtn () {
            if (this.recheckResult === '1') {
                if (this.remark === '') {
                    this.$message.warning('请输入异常描述');
                    return false;
                }
                if (this.imgArr.length === 0) {
                    this.$message.warning('请上传附件图片');
                    return false;
                }
            }
            this.loading();
            const saveApi = this.isSignCenter ? api.saveFromSignCenter : api.recordSave;
            const path = [];
            for (const value of this.imgArr) {
                path.push(value.path);
            };
            const param = {
                remark: this.remark,
                taskNo: this.rowData.taskNo,
                recheckResult: this.recheckResult,
                attachmentDtoList: path
            };
            saveApi(param)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('保存成功');
                        this.beforeClose();
                        this.$emit('finish');
                    }
                })
                .finally(() => {
                    this.loading(false);
                });
        },
        uploadResponse (response) {
            const uploadFile = {
                name: response[0].data.name,
                path: response[0].data.downUrl
            };
            this.imgArr.push(uploadFile);
            if (this.imgArr.length) {
                this.updateTime = response[0].timestamp;
                this.updateUserName = this.user.userName;
            };
            this.updateViewer();
        },
        beforeClose () {
            this.$emit('update:reviewShow', false);
        },
        updateViewer () {
            this.carouselIndex = 0;
            this.viewer.destroy();
            setTimeout(() => {
                this.initViewer();
            });
        },
        // 删除图片
        deleteBtn () {
            this.imgArr.splice(this.carouselIndex, 1);
            this.updateViewer();
        },
        downloadBtn () {
            window.location = this.imgArr[this.carouselIndex].path;
        },
        initViewer () {
            const barOptions = { show: true, size: 'small' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: true,
                button: true,
                toolbar: {
                    zoomIn: barOptions,
                    zoomOut: barOptions,
                    prev: {
                        show: true,
                        size: 'small',
                        click: () => {
                            if (this.carouselIndex === 0) {
                                this.carouselIndex = this.imgArr.length - 1;
                            } else {
                                this.carouselIndex -= 1;
                            }
                            this.viewer.prev(true);
                        }
                    },
                    reset: barOptions,
                    next: {
                        show: true,
                        size: 'small',
                        click: () => {
                            if (this.carouselIndex === this.imgArr.length - 1) {
                                this.carouselIndex = 0;
                            } else {
                                this.carouselIndex += 1;
                            }
                            this.viewer.next(true);
                        }
                    },
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
        }
    },
    created () {
        this.$nextTick(() => {
            this.initViewer();
        });
    },
    computed: {
        ...mapState({ user: state => state.user }),
        ...mapGetters(['user'])
    },
    beforeDestroy () {
        this.viewer.destroy();
    }
};
</script>

<style lang="less">
.receiptReviewDialog {
    .notImg {
        border-radius: 4px;
        border: 2px dashed #00bcbf;
        color: #00bcbf;
        font-size: 40px;
        width: 130px;
        line-height: 130px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -65px;
        margin-top: -65px;
    }
    .upload {
        position: relative;
        height: 300px;
    }
    .el-upload {
        text-align: center;
    }
    .remark {
        margin-top: 20px;
    }
    .errorInput {
        margin-top: 10px;
    }
    .contentBox {
        display: flex;
    }
    .contentBox-img {
        width: 60%;

        .attachmentTitle {
            margin: 10px 0;
            display: flex;
            justify-content: space-between;
        }
    }
    .contentBox-remark {
        flex: 1;
        padding: 20px;
        padding-top: 4px;
    }
    .attachmentLeft {
        position: relative;
        .loadingBox {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: #fff;
            z-index: 1000;
            .progress {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
        }
        .carousel {
            text-align: center;
            .receiveImgs {
                height: 100%;
            }
        }
    }
    .uploader {
        padding-top: 15px;
        text-align: center;

        > div {
            display: inline-block;
        }
        .pictures {
            border-radius: 4px;
            border: 1px dashed #00bcbf;
            color: #00bcbf;
            width: 20px;
            line-height: 20px;
        }
        > i {
            cursor: pointer;
            color: #00bcbf;
            font-size: 22px;
            vertical-align: middle;
            margin-left: 30px;
        }
    }
}
</style>
